import { createEntityAdapter, EntityState } from '@reduxjs/toolkit';
import { on, reducer } from 'ts-action';
import { ClusterBeat } from '../clustering/clustering.types';
import * as beatsActions from './beats.actions';

export interface BeatsState extends EntityState<ClusterBeat> {
  selectedIds: Set<number>;
  hoveredId?: number;
  pinnedId?: number;
}

declare module 'react-redux' {
  interface DefaultRootState {
    beats: BeatsState;
  }
}

const beatsAdapter = createEntityAdapter<ClusterBeat>();
export const { selectAll, selectEntities, selectById } =
  beatsAdapter.getSelectors();

export const getInitialBeatsState = (): BeatsState =>
  beatsAdapter.getInitialState({ selectedIds: new Set() });

export default reducer<BeatsState>(
  getInitialBeatsState(),
  on(beatsActions.cleanUp, () => getInitialBeatsState()),
  on(beatsActions.load, (state, { beats }) =>
    beatsAdapter.setAll(state, beats),
  ),
  on(beatsActions.toggleHoveredBeat, (state, { id }) => ({
    ...state,
    hoveredId: id,
  })),
  on(beatsActions.togglePinnedBeat, (state, { id }) => ({
    ...state,
    pinnedId: id,
  })),
  on(beatsActions.select, (state, { ids }) => ({
    ...state,
    selectedIds: ids,
  })),
);
